import UrlGeneration from "@lovata/url-generation";
import noUiSlider from 'nouislider';

export default class ShopaholicFilterPrice {
	/**
	 * @param {ShopaholicProductList} obProductListHelper
	 */
	constructor(obProductListHelper = null) {
		this.obProductListHelper = obProductListHelper;
		this.sEventType = 'change';
		this.sFiledName = 'price';

		this.sInputMinPriceName = 'filter-min-price';
		this.sInputMaxPriceName = 'filter-max-price';

		this.sDefaultInputClass = '_shopaholic-price-filter';
		this.sInputSelector = `.${this.sDefaultInputClass}`;

		this.sSliderUiID = 'filter-bar';
		this.obPriceSlider = null;

		this.mediaQueryList = window.matchMedia('(min-width: 993px)');
		this.iFMinLimit;
		this.iFMaxLimit;
		this.iFMinPrice;
		this.iFMaxPrice;
		this.obMinInput;
		this.obMaxInput;


		this.iCallBackDelay = 1000;
	}

	/**
	 * Init event handlers
	 */
	init() {
		$(document).on(this.sEventType, this.sInputSelector, () => {

			if (this.sEventType === 'input') {
				clearTimeout(this.timer);
				this.timer = setTimeout(() => {
					this.priceChangeCallBack();
				}, this.iCallBackDelay);
			} else {
				this.priceChangeCallBack();
			}
		});

		$(document).on('input', this.sInputSelector, ({currentTarget}) => {

			const {value} = currentTarget;
			const correctValue = value.replace(/[^\d.]/g, '');
			currentTarget.value = correctValue; // eslint-disable-line no-param-reassign
		});


		const obInputList = $(this.setInputSelector);
		this.obMinInput = obInputList.find(`[name=${this.sInputMinPriceName}]`);
		this.obMaxInput = obInputList.find(`[name=${this.sInputMaxPriceName}]`);

		this.setInputData();
		this.initSliderPrice();


		this.obPriceSlider.on('slide', function (event) {
			$("input#min-price").val(event[0].slice(0, -3));
			$("input#max-price").val(event[1].slice(0, -3));
			clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				$("input#min-price").blur();
			}, 1000);
		});
	}

	isDesktop() {
		return this.mediaQueryList.matches;
	}

	priceChangeCallBack() {
		this.setInputData();
		UrlGeneration.init();
		UrlGeneration.remove('page');
		UrlGeneration.update();

		if (!this.obProductListHelper) {
			return;
		}
		this.prepareRequestData();
		if(this.isDesktop()) this.obProductListHelper.send();

	}

	setInputData() {
		// Get min price from filter input
		this.iFMinLimit = parseFloat(this.obMinInput.attr('min'));
		this.iFMaxLimit = parseFloat(this.obMaxInput.attr('max'))+1;
		if (this.iFMinLimit == this.iFMaxLimit) {
            this.iFMinLimit = 1;
		}

		this.iFMinPrice = this.obMinInput.val();
		this.iFMaxPrice = this.obMaxInput.val();


	}

	prepareRequestData() {

		if (this.iFMinPrice > 0 && this.iFMinPrice < this.iFMinLimit) {
			this.iFMinPrice = this.iFMinLimit;
			this.obMinInput.val(this.iFMinLimit);
		}

		if (this.iFMaxPrice > 0 && this.iFMaxPrice > this.iFMaxLimit) {
			this.iFMaxPrice = this.iFMaxLimit;
			this.obMaxInput.val(this.iFMaxLimit);
		}

		if (this.iFMinPrice === 0 && this.iFMaxPrice === 0) {
			UrlGeneration.remove(this.sFiledName);
		} else {
			UrlGeneration.set(this.sFiledName, [this.iFMinPrice, this.iFMaxPrice]);
		}



		this.updateSliderPrice();
	}

	/**
	 * Redeclare default selector of filter input
	 * Default value is "_shopaholic-price-filter"
	 *
	 * @param {string} sInputSelector
	 * @returns {ShopaholicFilterPrice}
	 */
	setInputSelector(sInputSelector) {
		this.sInputSelector = sInputSelector;

		return this;
	}

	/**
	 * Redeclare default event type
	 * Default value is "change"
	 *
	 * @param {string} sEventType
	 * @returns {ShopaholicFilterPrice}
	 */
	setEventType(sEventType) {
		this.sEventType = sEventType;

		return this;
	}

	/**
	 * Redeclare default input name with min price
	 * Default value is "filter-min-price"
	 *
	 * @param {string} sInputName
	 * @returns {ShopaholicFilterPrice}
	 */
	setInputMinPriceName(sInputName) {
		this.sInputMinPriceName = sInputName;

		return this;
	}

	initSliderPrice() {

		let iCurrentMinPrice = (this.iFMinPrice) ? this.iFMinPrice : this.iFMinLimit;
		let iCurrentMaxPrice = (this.iFMaxPrice) ? this.iFMaxPrice : this.iFMaxLimit;
		let nonLinearSlider = document.getElementById(this.sSliderUiID);

		if (this.obPriceSlider) this.obPriceSlider.destroy();

		this.obPriceSlider = noUiSlider.create(nonLinearSlider, {
			start: [iCurrentMinPrice, iCurrentMaxPrice],
			connect: true,
			decimals: 0,
			range: {
				min: this.iFMinLimit,
				max: this.iFMaxLimit
			},
			step: 100
		});
	}

	updateSliderPrice() {
		let iCurrentMinPrice = (this.iFMinPrice) ? this.iFMinPrice : this.iFMinLimit;
		let iCurrentMaxPrice = (this.iFMaxPrice) ? this.iFMaxPrice : this.iFMaxLimit;
		this.obPriceSlider.set([iCurrentMinPrice, iCurrentMaxPrice]);
		UrlGeneration.update();
	}




	/**
	 * Redeclare default input name with max price
	 * Default value is "filter-max-price"
	 *
	 * @param {string} sInputName
	 * @returns {ShopaholicFilterPrice}
	 */
	setInputMaxPriceName(sInputName) {
		this.sInputMaxPriceName = sInputName;

		return this;
	}

	/**
	 * Redeclare default URL filed name
	 * Default value is "price"
	 *
	 * @param {string} sFieldName
	 * @returns {ShopaholicFilterPrice}
	 */
	setFieldName(sFieldName) {
		this.sFiledName = sFieldName;

		return this;
	}
}
